export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "goodsReceiptReceivedQty",
            label: "Recevied Qty", 
            component: "text-field",
            width: "50%",
            dataType: "int",
          },
          {
            name: "goodsReceiptDate",
            label: "Received Date",
            component: "dateselector",
            width: "50%",
          },
        ],
        row2: [
          {
            name: "goodsReceiptTransporter",
            label: "Transporter",
            component: "text-field",
            type:"autocomplete",
            endpoint:"getCustomers",
            width: "50%",

          },
          {
            name: "goodsReceiptVehicleNo",
            label: "Vehicle No.",
            component: "text-field",
            width: "50%", 

          },
        ],
      },
    },
  ],
};
